import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-ensure-decline',
  standalone: false,
  templateUrl: './ensure-decline.component.html',
  styleUrl: './ensure-decline.component.scss',
})
export class EnsureDeclineComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EnsureDeclineComponent>
  ){

  }

  ngOnInit(): void {

  }

  onClick(action): void {
    this.dialogRef.close(action);
  }

}
